import React from 'react'
import styled from 'styled-components'
import { dimensions, spacing } from '~/constants/theme'

import Text, { FontStyle } from './Text'

const FilterOptionWrapper = styled.div`
  display: flex;
  gap: ${spacing.spacingMD};
  width: 100%;
`

const FilterOption = styled.button<{ $selected?: boolean }>`
  align-items: center;
  margin: 0;
  border: none;
  font: inherit;
  display: flex;
  justify-content: center;
  flex: 1;
  border-radius: ${dimensions.borderRadiusSM};
  padding: ${spacing.spacingMD};
  background: ${({ $selected }) =>
    $selected
      ? 'var(--chakra-colors-bg-emphasized)'
      : 'var(--chakra-colors-bg-muted-low)'};
  cursor: pointer;
  transition: background ease-in-out 200ms;

  ${({ $selected }) =>
    !$selected
      ? ` &:hover {
    background: var(--chakra-colors-border-subtle);
  } `
      : ''}

  ${({ $selected }) =>
    !$selected
      ? ` &:active {
    background: var(--chakra-colors-border-default);
  } `
      : ''}

  &:focus-visible {
    outline: 2px solid var(--chakra-colors-brand-fg);
    outline-offset: 2px;
  }
`
export interface FilterOption<V extends string | number = string | number> {
  default?: boolean
  label: string
  subLabel?: string
  value: V
}

interface FilterMenuProps<V extends string | number = string | number> {
  options: FilterOption<V>[]
  onChange: (value: V) => void
  selectedFilter?: V
  /** Accessible name for the group of filter buttons. */
  ariaLabel?: string
}

const FilterMenu = <V extends string | number = string | number>({
  options,
  onChange,
  selectedFilter,
  ariaLabel,
}: FilterMenuProps<V>) => {
  return (
    <FilterOptionWrapper
      className="filter-menu"
      role="group"
      aria-label={ariaLabel}
    >
      {options.map(({ value, label }) => {
        const isSelected = selectedFilter === value
        return (
          <FilterOption
            className="filter-menu--filter-option"
            key={value}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onChange(value)}
            $selected={isSelected}
          >
            <Text
              as="span"
              color="var(--chakra-colors-fg-default)"
              fontStyle={FontStyle.bSmall}
              style={isSelected ? { fontWeight: 'bold' } : {}}
            >
              {label}
            </Text>
          </FilterOption>
        )
      })}
    </FilterOptionWrapper>
  )
}

export default FilterMenu
